/**
 * Utility functions for extracting HTML assets from chat messages
 */

import { GamgeeChatMessageRead, AssetMessageFinalOutput } from '~/types/message';

export interface AvailableAsset {
  title: string;
  description: string;
  filename: string;
  sessionId: string;
}

/**
 * Extract HTML assets from an array of chat messages
 */
export function extractHtmlAssetsFromMessages(
  messages: GamgeeChatMessageRead[]
): AvailableAsset[] {
  const assets: AvailableAsset[] = [];

  for (const message of messages) {
    if (
      message?.message?.sender === 'gamgee' &&
      message?.message?.message_type === 'asset_message' &&
      message?.message?.final_output &&
      'assets' in message?.message?.final_output
    ) {
      const finalOutput = message?.message?.final_output as AssetMessageFinalOutput;
      
      // Filter for HTML assets only
      const htmlAssets = finalOutput?.assets?.filter(asset => 
        asset.filename.endsWith('.html')
      ) || [];

      // Add session ID to each asset
      htmlAssets.forEach(asset => {
        assets.push({
          ...asset,
          sessionId: message.session_id
        });
      });
    }
  }

  // Remove duplicates based on sessionId + filename
  const uniqueAssets = assets.filter((asset, index, self) => {
    return index === self.findIndex(a => 
      a.sessionId === asset.sessionId && a.filename === asset.filename
    );
  });

  // Sort by most recent first (assuming message order reflects recency)
  return uniqueAssets.reverse();
}